import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { InfoIconWithMessage } from "../../../shared/infoIcon/InfoIcon";
import styles from "./StoreId.module.scss";
import "../../../styles/sharedStyles.scss";
import { withTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import { logMsg } from "../../../common/Logger";
import DealerStoreIdClient from "../../../shared/clients/DealerStoreIdClient";
import HasPermissionTo from "../../../common/HasPermissionTo";
import PendingActionClient from "../../../shared/clients/PendingActionClient";
import {
  BLUESNAP_MARKETS,
  STORE_ID,
  STRIPE_MARKETS,
} from "../../../common/Constants";

class StoreId extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealers: [],
      buttonDisabled: true,
      isDataLoaded: false,
    };

    this.uploadStoreIds = this.uploadStoreIds.bind(this);
    this.isStripeMarket = false;
    const market = this.props.user.market;
    this.storeIdValidation = BLUESNAP_MARKETS.includes(market)
      ? "matchRegexp:^[1-9]\\d{3,9}$"
      : "matchRegexp:^[1-9]\\d{9}$";
    this.translationPrefix = BLUESNAP_MARKETS.includes(market)
      ? "BlueSnapId"
      : "StoreId";
    this.htmlValidation = ["required", this.storeIdValidation];
  }

  componentDidMount() {
    this.isStripeMarket = STRIPE_MARKETS.includes(this.props.user.market);
    if (this.isStripeMarket) {
      this.storeIdValidation =
        "matchRegexp:^[0-9]{6,10}$|acct_[a-zA-Z0-9]{16}$";
      this.htmlValidation = [this.storeIdValidation];
    }
    if (this.props.fromQuickstart) {
      this.props.showActionFooter(true);
      this.setState({
        dealers: this.props.dealerGroup.filter(
          (dealer) =>
            this.isMainDealer(dealer) || this.isNonOnboardedBranchDealer(dealer)
        ),
        isDataLoaded: true,
      });
    } else {
      this.getStoreIds();
    }
  }

  isMainDealer = (dealer) => this.props.user.isMainDealer(dealer.dealerType);

  isNonOnboardedBranchDealer = (dealer) =>
    !dealer.isOnboarded && this.props.user.isBranchDealer(dealer.dealerType);

  getStoreIds() {
    const dealerList = [];

    const dealerMap = {};
    this.props.dealerGroup &&
      this.props.dealerGroup.forEach((dealer) => {
        dealerMap[dealer.commonId] = dealer;
      });
    this.props.hideOrShow(true);
    DealerStoreIdClient.getStoreIds(this.props.user)
      .then((res) => {
        const storeIdData = res.result.dealerStoreIdData;

        const storeIdMap = {};
        storeIdData.forEach((dealer) => {
          storeIdMap[dealer.dealerCommonId] = dealer.storeId;
          const dealerFromMap = dealerMap[dealer.dealerCommonId];
          dealerFromMap.storeId = dealer.storeId;
          dealerList.push(dealerFromMap);
        });
        this.storeIdMap = storeIdMap;
        dealerList.sort((a, b) => {
          if (a.dealerType === "MDLR" || a.dealerType === "HUB") {
            return -1;
          } else if (b.dealerType === "MDLR" || b.dealerType === "HUB") {
            return 1;
          } else {
            return 0;
          }
        });
        this.setState({ dealers: dealerList });
      })
      .catch(() => {})
      .finally(() => {
        this.props.hideOrShow(false);
        this.setState({ isDataLoaded: true });
      });
  }

  storeIdChangeHandler = () => (event) => {
    const currentDealers = this.state.dealers;

    if (currentDealers) {
      const newDealers = currentDealers.map((dealer) => {
        if (event.target.name === dealer.commonId) {
          return { ...dealer, storeId: event.target.value };
        }
        return dealer;
      });

      let disabled = true;

      this.storeIdMap &&
        newDealers.forEach((dealer) => {
          if (disabled) {
            const storeIdValueFromMap = this.storeIdMap[dealer.commonId];

            if (storeIdValueFromMap !== dealer.storeId) {
              disabled = false;
            }
          }
        });

      this.setState({ dealers: newDealers, buttonDisabled: disabled });
    }
  };

  uploadStoreIds() {
    if (this.props.fromQuickstart) {
      this.props.onSubmit({ dealers: this.state.dealers });
    } else {
      const updatedList = this.state.dealers;
      const originalDealers = JSON.parse(JSON.stringify(this.state.dealers));
      const changed = [];
      let commonId;
      let copyIndex;
      for (const dealer in updatedList) {
        commonId = updatedList[dealer].commonId;
        copyIndex = originalDealers.indexOf(
          originalDealers.find((obj) => obj.commonId === commonId)
        );
        if (
          originalDealers[copyIndex].storeId !==
          parseInt(updatedList[dealer].storeId)
        ) {
          changed.push({
            dealerCommonId: commonId,
            storeId: this.isStripeMarket
              ? updatedList[dealer].storeId
              : parseInt(updatedList[dealer].storeId),
            updatedBy: this.props.user.userId,
          });
        }
      }
      this.props.hideOrShow(true);
      DealerStoreIdClient.saveStoreIds(changed, this.props.user.token)
        .then(() => {
          this.getStoreIds();
          this.removePendingAction();
          this.props.user.updateToggleDisabled(
            this.props.user.getDealerList(),
            STORE_ID
          );
        })
        .catch((err) => logMsg(err))
        .finally(() => {
          this.props.hideOrShow(false);
        });
      this.setState({ buttonDisabled: true });
    }
  }

  removePendingAction = () => {
    const pendingActionStatusForDealers =
      this.props.user.getPendingActionStatusForDealers(
        this.props.user.pendingActions,
        STORE_ID
      );
    if (pendingActionStatusForDealers.length !== 0) {
      this.props.hideOrShow(true);
      PendingActionClient.removeDealerPendingAction(
        this.props.user,
        this.props.user.getDealerList(),
        STORE_ID
      )
        .then(() => {
          this.props.getPendingActions();
        })
        .finally(() => {
          this.props.hideOrShow(false);
        });
    }
  };

  render() {
    const dealers = this.state.dealers;

    const subHeader = this.props.fromQuickstart
      ? this.props.t(`${this.translationPrefix}.subheaderFromQ`)
      : this.props.t(`${this.translationPrefix}.subheaderFromB`);
    const isfromNscDealerSearch =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "storeIdSubmit"
      ) && this.props.fromNscDealerSearch;
    return (
      this.state.isDataLoaded && (
        <div className="pageWrapper">
          <div className="pagePadding">
            <h1 id="storeIdHeader" className="pageTitle">
              {this.props.t(`${this.translationPrefix}.header`)}
            </h1>
            <div className="pageInfoWrapper">
              <InfoIconWithMessage message={subHeader} />
            </div>
          </div>
          <Grid
            container
            className={`${styles.columnHeaderRow} pagePaddingLeft pagePaddingRight`}
          >
            <Grid item xs={10} className={styles.columnHeader} id="site">
              {this.props.t("StoreId.site")}
            </Grid>
            <Grid
              item
              xs={2}
              className={`${styles.columnHeader} ${styles.extraPaddingRight}`}
              id="storeId"
            >
              {this.props.t(`${this.translationPrefix}.id`)}
            </Grid>
          </Grid>

          <ValidatorForm
            id="storeIdForm"
            ref={this.props.formRef}
            onSubmit={this.uploadStoreIds}
          >
            {dealers.map((dealer) => (
              <Grid
                container
                id="dealerRow"
                key={dealer.commonId}
                className={`${styles.dataRow} pagePaddingLeft pagePaddingRight`}
              >
                <Grid item xs={10} className={styles.dataRowCell}>
                  {dealer.name} ({dealer.dealerId + dealer.dealerSubcode})
                </Grid>
                <Grid item xs={2}>
                  <HasPermissionTo
                    perform={["storeId:write"]}
                    permissions={this.props.user.permissions.rolePermissions}
                    condition={!this.props.isMainViewingSDLR(dealer)}
                    render={() => {
                      return (
                        <TextValidator
                          data-testid="inputField"
                          style={{ width: "100%" }}
                          autoComplete="off"
                          name={dealer.commonId || dealer.dealerCommonId}
                          className={styles.storeIdInput}
                          variant="outlined"
                          value={dealer.storeId || ""}
                          onChange={this.storeIdChangeHandler(dealer.commonId)}
                          validators={this.htmlValidation}
                          errorMessages={[
                            this.props.t("StoreId.errorReq"),
                            this.props.t("StoreId.errorId"),
                          ]}
                        />
                      );
                    }}
                    noRender={() => {
                      return (
                        <div
                          className={styles.storeIdText}
                          data-testid="storeIdStatic"
                        >
                          {dealer.storeId ? dealer.storeId : "--"}
                        </div>
                      );
                    }}
                  />
                </Grid>
              </Grid>
            ))}
            <HasPermissionTo
              perform={["storeId:write"]}
              permissions={this.props.user.permissions.rolePermissions}
              condition={!this.props.fromQuickstart}
              render={() => {
                return (
                  <div
                    className={
                      this.state.buttonDisabled || isfromNscDealerSearch
                        ? "disabledButtonDiv"
                        : "confirmButton"
                    }
                  >
                    <button
                      disabled={
                        this.state.buttonDisabled || isfromNscDealerSearch
                      }
                      data-testid="saveBtn"
                      id="saveBtn"
                      type="submit"
                    >
                      {this.props.t("StoreId.saveAndUpdate")}
                    </button>
                  </div>
                );
              }}
            />
          </ValidatorForm>
        </div>
      )
    );
  }
}

export default withTranslation("emp")(StoreId);
